module.exports = __webpack_public_path__ + "assets/img/exanubabtuib-title.89a89ef4.png";